import React from 'react'
import GooglePayButton from '@google-pay/button-react'
import PropTypes from 'prop-types'
import { noop } from 'jquery'
import { EMPTY_OBJECT } from '../../../constants/globalConstants'

const GooglePayFS = (props) => {
    const { faciltyData, getValues, onSubmit, setIsSubmittingForm, isSubmittingForm , payableAmount} = props
    const paymentDataResponse = async (paymentResponse) => {
        setIsSubmittingForm(true)

        try {
            // Get the complete payment method data (includes signature, keys, etc.)
            const paymentMethodData = paymentResponse?.paymentMethodData
            const googlePayToken = paymentMethodData?.tokenizationData?.token

            const formData = getValues()
            const finalData = {
                ...formData,
                walletPay: googlePayToken,
                paymentMethods: 'GPAY'
            }
            await onSubmit(finalData, 0)
            // On success, button stays hidden (don't set isSubmittingForm to false)
        } catch (err) {
            // SAVE LOG TO API LOGS 
            console.error('GooglePayFS Error: ', err)
            // On error, show the button again
            setIsSubmittingForm(false)
        }
    }

    if (isSubmittingForm) {
        return null
    }

    return (
        <div className='px-2 payButton'>
            <GooglePayButton
                buttonColor='default'
                buttonType='buy'
                environment={
                    faciltyData?.facility_payment_details?.fiserv_environment
                }
                paymentRequest={{
                    apiVersion: 2,
                    apiVersionMinor: 0,
                    allowedPaymentMethods: [
                        {
                            type: 'CARD',
                            parameters: {
                                allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                                allowedCardNetworks: [
                                    'AMEX', 'DISCOVER', 'INTERAC', 'JCB', 'MASTERCARD', 'VISA'
                                ],
                            },
                            tokenizationSpecification: {
                                type: 'PAYMENT_GATEWAY',
                                parameters: {
                                    gateway: 'cardconnect',
                                    gatewayMerchantId:
                                        faciltyData?.facility_payment_details?.fiserv_mid
                                },
                            },
                        },
                    ],
                    merchantInfo: {
                        merchantId: faciltyData?.facility_payment_details?.fiserv_env,
                        merchantName: faciltyData?.facility_payment_details?.fiserv_apple_merchant_identifier
                    },
                    transactionInfo: {
                        totalPriceStatus: 'FINAL',
                        totalPriceLabel: 'Total',
                        totalPrice: Number(payableAmount)?.toFixed(2),
                        currencyCode: 'USD',
                        countryCode: 'US'
                    },
                }}
                onLoadPaymentData={paymentDataResponse}
            />
        </div>
    )
}

GooglePayFS.propTypes = {
    faciltyData: PropTypes.object,
    getValues: PropTypes.func,
    onSubmit: PropTypes.func,
    setIsSubmittingForm: PropTypes.func,
    isSubmittingForm: PropTypes.bool,
    payableAmount: PropTypes.number,
}

GooglePayFS.defaulProps = {
    faciltyData: EMPTY_OBJECT,
    getValues: noop,
    onSubmit: noop,
    setIsSubmittingForm: noop,
    isSubmittingForm: false,
    payableAmount: 0,
}

export default GooglePayFS
